import { promiseFetchDataAuth } from "crk-front-lib";
const { URL_SUBSCRIPTION } = require('../configs/constant.json');

export function querySubscription(app_id, callback) {
  const uri = URL_SUBSCRIPTION + `/${app_id}`
  promiseFetchDataAuth(uri, "GET")
  .then(result => {
    // console.info(result);
    if(callback) {
      callback(null, result);
    }
  })
  .catch(err => {
    callback(err);
  })
}